import React from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { Button, Col, Modal, ModalFooter, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

// Own constants/actions/components
import { AMEX_LINK, SANTANDER_LINK } from 'constants/Constants';

const ModalExclusivity = ({ stateInitial, path, itemsCart, removeFunc }) => {
  const history = useHistory();

  const handleRemoveExclusiveExperience = (isLoggedIn) => {
    itemsCart.map((item) => removeFunc(item.id));
    if (isLoggedIn) {
      history.push('/home/#experiencias');
    } else {
      history.push(`/${path}`);
    }
  };

  const footerIfNotLoggedIn = () => {
    return (
      <>
        <ModalFooter className="border-top-0 pt-0">
          { itemsCart.length > 1 ? (
            <h4 className="text-tangaroa">
              Hemos removido las Experiencias de tu carrito.
              Para adquirir el resto de tus Experiencias da clic en ‘Ir al carrito’.
            </h4>
          ) : (
            <h4 className="text-tangaroa">
              Hemos removido la Experiencia de tu carrito.
              Para adquirir el resto de tus Experiencias da clic en ‘Ir al carrito’.
            </h4>
          )}
        </ModalFooter>
        <Modal.Footer className="border-top-0">
          <Button variant="primary" onClick={() => handleRemoveExclusiveExperience(false)}>
            Ir al carrito
          </Button>
        </Modal.Footer>
      </>
    );
  };

  const footerIfLoggedIn = () => {
    return (
      <>
        <ModalFooter className="border-top-0 pt-0 justify-content-start">
          <h4 className="text-tangaroa">
            Haz click en el botón ‘Navegar’ para buscar más Experiencias.
          </h4>
        </ModalFooter>
        <Modal.Footer className="border-top-0">
          <Button variant="primary" onClick={() => handleRemoveExclusiveExperience(true)}>
            Navegar
          </Button>
        </Modal.Footer>
      </>
    );
  };

  return (
    <Modal show={stateInitial} size="md">
      <Modal.Header>
        <Modal.Title>
          { itemsCart.length > 1 ? (
            <h3>Lo sentimos, estas Experiencias son exclusivas para Tarjetahabientes.</h3>
          ) : (
            <h3>Lo sentimos, esta Experiencia es exclusiva para Tarjetahabientes.</h3>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled text-tangaroa">
          {
            /* eslint-disable */
            itemsCart.map((item, index) => (
              <li className="gift-label text-left gift-label mb-3" key={index}>
                <Row>
                  <Col lg={6}>
                    <h4 className="text-tangaroa text-bold">{item.title}</h4>
                    { item.exclusivity === 'SANTANDER' ? (
                      <span className="exclusivity-span-santander ft-12">
                        <span>Exclusivo Tarjetahabientes Santander Aeroméxico</span>
                      </span> ) : ''
                    }
                    { item.exclusivity === 'AMEX' ? (
                      <span className="exclusivity-span-amex ft-12">
                        <span>Exclusivo Tarjetahabientes American Express® Aeroméxico</span>
                      </span> ) : ''
                    }
                  </Col>
                  <Col lg={6}>
                    <img src={item.image} alt={`exclusivity-${item.id}`} width="100%" />
                  </Col>
                  <Col lg={12}>
                    { item.exclusivity === 'SANTANDER' ? (
                        <h4 className="pt-15 text-tangaroa text-bold">
                          Si deseas adquirir la Tarjeta Santander Aeroméxico da
                          {' '}
                          <a href={SANTANDER_LINK}>click aquí.</a>
                        </h4>) : ''
                    }
                    { item.exclusivity === 'AMEX' ? (
                      <h4 className="pt-15 text-tangaroa text-bold">
                        Si deseas adquirir la Tarjeta American Express® Aeroméxico da
                        {' '}
                        <a href={AMEX_LINK}>click aquí.</a>
                      </h4>) : ''
                    }
                  </Col>
                </Row>
              </li>
            ))
          }
        </ul>
      </Modal.Body>
      {
        Cookies.get('frontSession') !== undefined && history.location.pathname !== '/mis-experiencias' ? footerIfLoggedIn() : footerIfNotLoggedIn()
      }
    </Modal>
  );
};

ModalExclusivity.propTypes = {
  stateInitial: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  removeFunc: PropTypes.func.isRequired,
  itemsCart: PropTypes.array.isRequired,
};

export default ModalExclusivity;
